export const environment = {
  production: false,
  appVersion: 'v1.0.0',
  userDataKey: 'User-f751fc9a5f59',
  userRoleDataKey: 'Role-f751fc9a5f59',
  authBaseUri:"https://auth.peakup.org",
  //apiUri:'https://localhost:5000',
  apiUri:'https://velocity-advance-dev.peakup.org'
};